import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { EffectFade, Autoplay, Navigation } from "swiper";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { hotelAssets } from "../assets/hotelAssets";
import {
  HOTEL_ABOUT_TAGLINE,
  HOTEL_ABOUT_TITLE,
  HOTEL_CITY,
  HOTEL_LOCATION_LABEL,
  HOTEL_NAME,
  HOTEL_NEARBY_LANDMARK,
  HOTEL_ROOM_SUMMARY,
} from "../config/hotel";

const images = hotelAssets.aboutSlides;

const AboutPage = () => {
  const navigate = useNavigate();

  const handleCheckNowClick = () => {
    navigate("/rooms");
  };

  return (  
    <div className="relative">  
      <div  
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"  
        style={{ backgroundImage: `url(${hotelAssets.aboutBackground})` }}  
      ></div>  
      <div className="relative z-10">  
        <Header />  
        <div className="container mx-auto pt-32 py-12 flex flex-wrap lg:flex-nowrap">  
          <div className="w-full lg:w-1/2 lg:pr-8 relative mb-8 lg:mb-0">  
            <Swiper  
              modules={[EffectFade, Autoplay, Navigation]}  
              effect="fade"  
              loop={true}  
              autoplay={{  
                delay: 3000,  
                disableOnInteraction: false,  
              }}  
              navigation={true}  
              className="h-[300px] lg:h-[600px]"  
            >  
              {images.map((image, index) => (  
                <SwiperSlide  
                  key={index}  
                  className="flex justify-center items-center"  
                >  
                  <img  
                    src={image}  
                    alt={`About ${index + 1}`}  
                    className="object-cover h-full w-full cursor-pointer"  
                  />  
                </SwiperSlide>  
              ))}  
            </Swiper>  
          </div>  
          <div className="w-full lg:w-1/2 lg:pl-8">  
            <h3 className="text-3xl font-bold mb-4">{HOTEL_ABOUT_TITLE}</h3>  
            <h4 className="text-2xl font-semibold mb-2">{HOTEL_ABOUT_TAGLINE}</h4>  
            <p className="text-lg mb-4">  
              Welcome to *{HOTEL_NAME}*, where comfort meets elegance.  
              Our hotel features a selection of *{HOTEL_ROOM_SUMMARY}* designed for ultimate relaxation and style.  
            </p>  
            <h4 className="text-2xl font-semibold mb-2">The Ideal Location</h4>  
            <p className="text-lg mb-4">  
              Located in the *{HOTEL_LOCATION_LABEL}*, we offer a perfect blend of charm,  
              tranquility, and accessibility. Ideal for both leisure and business travelers,   
              our hotel serves as a gateway to explore the nearby *{HOTEL_NEARBY_LANDMARK}*   
              and the vibrant city of *{HOTEL_CITY}*.  
            </p>  
            <h4 className="text-2xl font-semibold mb-2">Exceptional Service</h4>  
            <p className="text-lg mb-4">  
              At *{HOTEL_NAME}*, our dedicated staff is committed to providing  
              personalized and attentive service. Our goal is to ensure that each guest has   
              a seamless and memorable experience during their stay.  
            </p>  
            <h4 className="text-2xl font-semibold mb-2">Amenities & Facilities</h4>  
            <p className="text-lg mb-4">  
              Spread across five floors, our hotel features a modern lift for easy access.  
              Enjoy our inviting lounge, where you can unwind with drinks, snacks, or a good book.  
              Don't miss our splendid terrace, perfect for relaxing in the lively atmosphere  
              of daily life from morning till evening.  
            </p>  
            {/* Book Now Button */}  
            <div className="flex justify-end mt-4">  
              <button  
                onClick={handleCheckNowClick}  
                className="bg-red-600 text-white px-6 py-3 rounded-lg shadow-lg hover:bg-red-700 transition duration-300"  
              >  
                Check Now  
              </button>  
            </div>  
          </div>  
        </div>  
      </div>  
    </div>  
  );  
};  

export default AboutPage;
